import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getSitelinkExtensionStyles } from '../styles';

const SitelinkExtension = ({
  classes,
  extensionData,
}) => {
  const onRenderTile = useCallback(({
    DisplayText, Description1, Description2, DestinationUrl, FinalUrls,
  }) => {
    let distUrl;
    if (DestinationUrl) {
      distUrl = DestinationUrl;
    } else if (FinalUrls && FinalUrls.length > 0) {
      [distUrl] = FinalUrls;
    } else {
      distUrl = '';
    }
    if (distUrl && distUrl.indexOf('http') !== 0) {
      distUrl = `http://${distUrl}`;
    }

    return (
      <div className="sitelink-tile">
        <a className="title" href={distUrl} target="_blank" rel="noreferrer">{DisplayText}</a>
        {Description1 && <div className="text">{Description1}</div>}
        {Description2 && <div className="text">{Description2}</div>}
      </div>
    );
  }, []);

  const tiles = [];
  for (let i = 0; i < extensionData.length; i += 2) {
    const current = extensionData[i];
    const next = i + 1 < extensionData.length ? extensionData[i + 1] : null;
    tiles.push((
      <div className="sitelink-row">
        {onRenderTile(current)}
        {next && onRenderTile(next)}
      </div>
    ));
  }

  return (
    <div className={classes.sitelinkExtensionContainer}>
      {tiles}
    </div>
  );
};

SitelinkExtension.propTypes = {
  classes: PropTypes.shape({
    sitelinkExtensionContainer: PropTypes.string,
  }),
  extensionData: PropTypes.arrayOf(PropTypes.shape({
    DisplayText: PropTypes.string,
    Description1: PropTypes.string,
    Description2: PropTypes.string,
    DestinationUrl: PropTypes.string,
    FinalUrls: PropTypes.arrayOf(PropTypes.string),
  })),
};

SitelinkExtension.defaultProps = {
  classes: {},
  extensionData: [],
};

export const AdPreviewSitelinkExtension = withUAPLThemedStyles(
  SitelinkExtension,
  getSitelinkExtensionStyles, { componentName: 'AdPreviewSitelinkExtension' }
);
